import React, { useEffect, useState } from 'react';

import { Box, Tag } from '@chakra-ui/react';
import { EditorState } from 'draft-js';
import { areSameIds } from 'screens/home/addPost/AddPostModal/ApplicableCompenciesSectionRabbit';
import { CollapsableCompetencyRabbit } from 'screens/home/addPost/AddPostModal/CollapsableCompetencyRabbit';
import { addMention } from 'screens/home/addPost/mentionHelper';

import { replaceTextOfAllEntities } from 'services/helpers/post';

import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

import { useApplicableCompetenciesQuery } from '../hooks/feedbackDataHook';

interface Props {
  editorState: EditorState;
  setApplicableEmployeeIds: (employeeIds: string[]) => void;
  setCompetency: (editorState: EditorState) => void;
}

const addCompetencyToEditorState = (editorState, competency) => {
  // use it for adding a mention entity to editorState
  // Copied this addMention function from official mention plugin of draft js
  const newEditorState = addMention(editorState, competency, ' #', '#', true);
  return newEditorState;
};

const FeedbackCompetencies = ({ editorState, setApplicableEmployeeIds, setCompetency }: Props) => {
  const [mentionedEmployeeIds, setMentionedEmployeeIds] = useState([]);

  const { data: applicableCompetencies, isLoading } = useApplicableCompetenciesQuery({
    mentionedEmployeeIds,
  });

  const [mentionedCompetencies, setMentionedCompetencies] = useState([]);

  const addTag = (tag) => {
    const newEditorState = addCompetencyToEditorState(editorState, tag);
    setCompetency(newEditorState);
  };

  useEffect(() => {
    if (editorState) {
      const body = {
        macros: {
          employees: {},
          demographics: {},
          attributes: { orgTag: {}, money: null },
        },
      };

      replaceTextOfAllEntities(editorState, body);

      const newMentionedEmployeeIds = Object.keys(body.macros.employees);
      const newMentionedCompetencies = Object.keys(body.macros.attributes.orgTag);

      if (!areSameIds(mentionedEmployeeIds, newMentionedEmployeeIds)) {
        setMentionedEmployeeIds(newMentionedEmployeeIds);
        setApplicableEmployeeIds(newMentionedEmployeeIds);
      }

      if (!areSameIds(mentionedCompetencies, newMentionedCompetencies)) {
        setMentionedCompetencies(newMentionedCompetencies);
      }
    }
  }, [editorState]);

  return isLoading ? (
    <SkeletonLoader />
  ) : (
    <Box mt="8px" overflow="auto">
      <CollapsableCompetencyRabbit>
        {applicableCompetencies?.map((tag) => (
          <Tag
            sx={{
              marginRight: '8px',
              marginTop: '8px',
              cursor: 'pointer',
            }}
            key={tag.uuid}
            onClick={() => addTag(tag)}
            background="#F2F2F2"
          >
            {tag?.displayName}
          </Tag>
        ))}
      </CollapsableCompetencyRabbit>
    </Box>
  );
};

export default FeedbackCompetencies;
